// @ts-check
"use strict"

import React, { useId, useRef, useState } from "react"
import InfoPopup from "@minohealth/common/components/info-popup"
import { useDispatch } from "react-redux"
import { setHasDiscardedDisclaimer } from "@minohealth/common/services/DataStoreService/reducers/AppReducer"

import "./disclaimer-popup.css"

export default function DisclaimerPopup() {
  const discardPopupId = useId()
  const [shouldDiscard, setShouldDiscard] = useState(false)
  const dispatch = useDispatch()
  const clickedOkayRef = useRef(false)

  /** @param {React.SyntheticEvent<HTMLDialogElement, Event>} ev */
  function handleClose(ev) {
    if (clickedOkayRef.current && shouldDiscard) {
      dispatch(setHasDiscardedDisclaimer(true))
    }

    clickedOkayRef.current = false
    setShouldDiscard(false)
  }

  return (
    <InfoPopup
      data-test="info-popup"
      open
      showCloseButton={false}
      onClose={handleClose}
      onCancel={ev => ev.preventDefault()}
      header={(
        <InfoPopup.Title>Disclaimer</InfoPopup.Title>
      )}
      footer={(
        <InfoPopup.WithContext>
          {({ closePopup }) => (
            <InfoPopup.ButtonGroup className="disclaimer-popup__footer-content">
              <div className="disclaimer-popup__discard-field">
                <input
                  type="checkbox"
                  id={`${discardPopupId}__discard-checkbox`}
                  checked={shouldDiscard}
                  onChange={ev => setShouldDiscard(ev.target.checked)}
                />
                <label htmlFor={`${discardPopupId}__discard-checkbox`}>Don't show this again</label>
              </div>

              <InfoPopup.Button
                data-test="info-popup-btn"
                onClick={() => {
                  clickedOkayRef.current = true
                  closePopup()
                }}
              >Okay</InfoPopup.Button>
            </InfoPopup.ButtonGroup>
          )}
        </InfoPopup.WithContext>
      )}
    >
      <p>The information provided by MinoHealth on this application such as text graphics, images and any other advice is for informational purposes only and is not substitute for professional medical advice, diagnosis or treatment. We do not guarantee the completeness or accuracy of any of the information provided on the website or application.</p>
      <p>We recommend that you consult a medical professional before acting on any information provided on this application or website. Reliance on any information provided on this application is solely at your own risk. MinoHealth will not be liable to users for any damages incurred based on decision made or actions taken in reliance on the information provided on this application or website.</p>
    </InfoPopup>
  )
}